import { STAGE_HOSTS } from '@common/constants';

// the hostname parameter exists for tests: jsdom 26 made window.location unforgeable
export function getSentryEnvironment(hostname: string = location.hostname): 'staging' | 'production' | 'local' {
  if (hostname.includes('localhost')) {
    return 'local';
  }

  if (hostname.includes('stage') || STAGE_HOSTS.includes(hostname)) {
    return 'staging';
  }

  return 'production';
}
